import React, { useEffect, useState } from "react";
import { api, formatIDR } from "@/lib/api";
import { Card, Btn, Field, Input } from "@/components/erp/ui";
import { toast } from "sonner";
import { Zap, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ExpressRulesSettings = () => {
  const { user } = useAuth();
  const isOwner = user?.role === "owner";
  const [cats, setCats] = useState([]);
  const [rules, setRules] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/catalog/categories").then(({ data }) => setCats(data)).catch(() => {});
    api.get("/settings/express-rules").then(({ data }) => setRules(data)).catch(() => {});
  }, []);
  if (!rules) return <p className="text-sm text-slate-400">Memuat…</p>;
  const off = rules.no_express_category_ids || [];
  const toggle = (id) => setRules({ ...rules, no_express_category_ids: off.includes(id) ? off.filter((x) => x !== id) : [...off, id] });
  const save = async () => {
    setBusy(true);
    try { await api.put("/settings/express-rules", { no_express_category_ids: off, rush_fee_percent: +rules.rush_fee_percent, express_minimum: +rules.express_minimum, express_buffer_h: +rules.express_buffer_h }); toast.success("Aturan Express disimpan"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal menyimpan"); }
    setBusy(false);
  };
  return (
    <Card className="p-5 space-y-3" data-testid="express-rules">
      <div className="flex items-center gap-2 font-semibold text-sm"><Zap className="w-4 h-4 text-amber-500" /> Express Time — Biaya Produksi Katalog</div>
      <p className="text-xs text-slate-500">Rumus sama dengan Kalkulator Harga: biaya +{rules.rush_fee_percent}% (min {formatIDR(rules.express_minimum)}), lead time = ½ lead time reguler (hari berjalan, Sabtu–Minggu terhitung). Matikan Express untuk kategori tertentu di bawah — berlaku di Kalkulator Design & Quotation.</p>
      {!isOwner && <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 flex items-center gap-1.5" data-testid="express-owner-only"><Lock className="w-3.5 h-3.5" /> Hanya admin utama (owner) yang dapat mengubah pengaturan ini.</p>}
      <div className="grid sm:grid-cols-2 gap-3">
        <Field label="Biaya Express (% dari biaya produksi)"><Input type="number" min="0" disabled={!isOwner} data-testid="express-fee-pct" value={rules.rush_fee_percent} onChange={(e) => setRules({ ...rules, rush_fee_percent: e.target.value })} /></Field>
        <Field label="Minimum biaya Express (Rp)"><Input type="number" min="0" disabled={!isOwner} data-testid="express-min" value={rules.express_minimum} onChange={(e) => setRules({ ...rules, express_minimum: e.target.value })} /></Field>
        <Field label="Express buffer (jam) — tambahan waktu cetak Kalkulator"><Input type="number" min="0" disabled={!isOwner} data-testid="express-buffer" value={rules.express_buffer_h ?? 8} onChange={(e) => setRules({ ...rules, express_buffer_h: e.target.value })} /></Field>
      </div>
      <fieldset disabled={!isOwner} className="grid sm:grid-cols-2 gap-1.5">
        {cats.map((c) => {
          const on = !off.includes(c.id);
          return (
            <label key={c.id} className={`flex items-center justify-between gap-2 min-w-0 px-3 py-2 rounded-lg border text-sm cursor-pointer ${on ? "border-amber-200 bg-amber-50/50" : "border-slate-200 bg-slate-50 text-slate-400"}`} data-testid={`express-cat-${c.id}`}>
              <span className="truncate min-w-0">{c.name}</span>
              <span className="flex items-center gap-1.5 text-[11px] shrink-0">{on ? "Express boleh" : "Tanpa Express"}
                <input type="checkbox" checked={on} onChange={() => toggle(c.id)} data-testid={`express-cat-toggle-${c.id}`} />
              </span>
            </label>
          );
        })}
      </fieldset>
      {isOwner && <div className="flex justify-end"><Btn data-testid="express-rules-save" onClick={save} disabled={busy}>{busy ? "Menyimpan…" : "Simpan"}</Btn></div>}
    </Card>
  );
};
